<template>
    <div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item active"><router-link to="/index">{{tryout.nama_materi}}</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">{{tryout.nama_sub_materi}}</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Pembahasan {{tryout.nama_to}} </h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				
				<div class="custom-container">
					<div class="row">
					
						<!-- Profile Sidebar -->
						<!-- <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                <Sidebar />
						</div> -->
						<!-- /Profile Sidebar -->
						
                        
						<div class="col-md-12 col-lg-12 col-xl-12 dct-appoinment">
							<!-- <div class="card"> -->
                                <div class="row">
                                    <div class="col-md-7 col-lg-8">
                                        <div class="card">
                                            <div class="card-header">
                                                <div class="login-header">
                                                    <h3>Soal Nomor {{idxSoal}}
                                                        <button v-if="soal.ket_laporan" class="btn btn-rounded float-right" :class="{'btn-outline-danger': !soal.ket_laporan, 'btn-outline-warning': soal.ket_laporan}" @click="getLaporan()"><i class="fa fa-info-circle"></i> {{soal.ket_laporan ? "Lihat laporan soal":""}} </button>
                                                    </h3>
                                                </div>
                                                <!-- <h4 class="card-title">Soal Nomor {{idxSoal}}
                                                <div class="col-auto text-center float-right ml-auto">
                                                    <button class="btn btn-danger"><i class="fa fa-info"></i> Laporkan Soal</button>
                                                </div>
                                                </h4> -->
                                            </div>
                                            <!-- Checkout Form -->
                                            <form>
                                                <div class="card-body">
                                            
                                                
                                                    <!-- Personal Information -->
                                                    <div class="info-widget">

                                                        <div class="row">
                                                            <div class="col-md-12 col-sm-12">
                                                                <div class="titleContainer title " v-html="soal.uraian_soal"></div>

                                                                <!-- quizOptions -->
                                                                <div class="optionContainer">
                                                                <!-- <tr v-for="(opsi,i) in this.list_jawaban" :key="opsi.id_jawaban"> -->

                                                                    <div class="option" v-for="(response, idx) in this.list_jawaban" :key="idx"
                                                                    @click="selectOption(response.id_jawaban)" :class="{'bg-info-light': ((response.poin == 5 && response.id_jawaban != soal.jawaban_user && soal.poin <=0) || (soal.poin >0  && response.id_jawaban == soal.jawaban_user)), 'bg-danger-light': ((response.poin < 5) || (soal.jawaban_user == response.id_jawaban && response.poin<=0))}">
                                                                        <span style="margin-right:5px"> {{ response.jawaban }}.</span> 
                                                                        <span v-html="response.uraian_jawaban" style="display:inline-block"></span>
                                                                        <button class="float-right">
                                                                            <!-- <span v-if="soal.jawaban_user == response.id_jawaban">Poin Jawaban : {{soal.poin}}</span> &nbsp; -->
                                                                            <span>Poin Jawaban : {{response.poin}}</span> &nbsp;
                                                                            <i class="fa" :class="{'fa-check':((soal.poin >0  && response.id_jawaban == soal.jawaban_user)), 'fa-times': (soal.jawaban_user == response.id_jawaban && response.poin<=0)}"></i> </button>
                                                                        
                                                                    </div>
                                                                </div>
                                                                
                                                            </div>
                                                        </div>

                                                        
                                                    </div>

                                                    <div>
                                                        <div class="login-header">
                                                                <h3>Pembahasan</h3>
                                                        </div>
                                                        <div class="alert alert-warning " v-html="soal.pembahasan"></div>

                                                        <!-- <button class="btn btn-rounded btn-outline-primary" @click.prevent="selectOption(-1)">Kosongkan Jawaban</button> -->
                                                    </div>
                                                </div>
                                                <div class="card-footer">
                                                    <div class="text-center">
                                                        <button class="btn btn-rounded btn-light" @click.prevent="setRowSoal(--index)" v-if="index > 0"><i class="fas fa-arrow-left"></i> Sebelumnya</button>
                                                        <button class="btn btn-rounded btn-dark" @click.prevent="setRowSoal(++index)" v-if="index < lstsoal.length - 1">Selanjutnya <i class="fas fa-arrow-right"></i></button>
                                                    </div>
                                                </div>
                                            
                                            </form>
                                            <!-- /Checkout Form -->
                                        </div>
                                        
                                    </div>
                                    
                                    <div class="col-md-5 col-lg-4 theiaStickySidebar">
                                    
                                        <!-- Booking Summary -->
                                        <div class="card booking-card">
                                            <div class="card-header">
                                                <div class="login-header">
                                                    <h4>NILAI ANDA
                                                        <div class="btn btn-outline-primary float-right">{{tryout.hasil}}
                                                        </div>
                                                    </h4>
                                                </div>
                                                <!-- <h4 class="card-title">Booking Summary</h4> -->
                                                
                                                
                                            </div>
                                            <div class="card-body">
                                                <!-- <div class="row">
                                                    <div class="col-auto text-center float-right ml-auto">
                                                        <div class="btn-toolbar">
                                                            <div class="btn-group btn-group-sm">
                                                                <button class="btn btn-light" @click="setRowSoal(--index)" v-if="index >= 0"> Prev</button>
                                                                <button class="btn btn-light" @click="setRowSoal(++index)" v-if="index < lstsoal.length - 1">Next</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->
                                                
                                                <!-- <div class="card booking-schedule schedule-widget"> -->
                                                    <!-- Schedule Content -->
                                                    <div class="schedule-cont">
                                                        <!-- <div class="row">
                                                            <div class="col-md-12"> -->
                                                            
                                                                <!-- Time Slot -->
                                                                <div class="quiz-slot" style="padding:0px">
                                                                    <ul class="clearfix">
                                                                        <li v-for="(data,i) in lstsoal" :key="data.soal.id_soal">
                                                                            <a :class="{'timing': true, 'filled-check' : parseFloat(data.soal.poin) > 0 , 'filled-kosong' : data.soal.poin === null , 'filled-times':(parseFloat(data.soal.poin) <= 0), 'active' : i === index}" @click.prevent="setRowSoal(i)">
                                                                                <span> <i :class="{'fa':true, 'fa-times':(parseFloat(data.soal.poin) <= 0), 'fa-check': parseFloat(data.soal.poin) > 0}">&nbsp;</i> {{i+1}}</span>
                                                                            </a>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                                <!-- /Time Slot -->
                                                                
                                                            <!-- </div>
                                                        </div> -->
                                                    </div>
                                                    <!-- /Schedule Content -->
                                                    <!-- <div class="schedule-cont">
                                                        <div class="row">
                                                            <div class="col-auto text-center float-center ml-auto">
                                                                <div class="btn-toolbar">
                                                                    <div class="btn-group btn-group-sm">
                                                                        <button class="btn btn-light" @click="setRowSoal(--index)" v-if="index >= 0"> Batal</button>
                                                                        <button class="btn btn-light" @click="setRowSoal(++index)" v-if="index < lstsoal.length - 1">Selesai</button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div> 
                                                    </div> -->
                                                <!-- </div> -->
                                            </div>
                                            <div class="card-footer">
                                                
                                                <div class="text-center">
                                                    <router-link to="/admin/tryout" class="btn btn-rounded btn-info">Kembali</router-link> 
                                                    <!-- @click.prevent="getBatal()" -->
                                                    <!-- <button class="btn btn-rounded btn-outline-primary" data-toggle="modal" data-target="#selesaiMdl" >Selesai</button> -->
                                                </div>
                                            </div>
                                        </div>
                                        <!-- /Booking Summary -->
                                        
                                    </div>
                                </div>
                            <!-- </div> -->
                        </div>
                    </div>

				</div>


			</div>	                          	
			<!-- /Page Content -->
   
			<!-- Footer -->
				<layout-footer />
			<!-- /Footer -->
		   
		</div>
		<!-- /Main Wrapper -->

        <div id="batalMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Batalkan Try Out</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan membatalkan try out {{tryout.nama_to}}?</label>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">                        
                        <div class="submit-section float-center">
                            <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div id="selesaiMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Kirim Try Out</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda sudah yakin dengan jawaban dan ingin mengakhiri try out {{tryout.nama_to}}?</label>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">                        
                        <div class="submit-section float-center">
                            <button class="btn btn-primary submit-btn" @click.prevent="selesai">Yakin</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="nilaiMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body">
                        <!-- <div class="card success-card">
                            <div class="card-body"> -->
                                <div class="success-cont">
                                    <i class="fas fa-check"></i>
                                    <h3>Selamat anda telah menyelesaikan Tryout {{tryout.nama_to}}!</h3>
                                    <p>Nilai yang anda dapatkan adalah <strong> {{tryout.hasil}} </strong></p>
                                    <router-link to="/admin/tryout" class="btn btn-primary view-inv-btn">Selesai</router-link>
                                </div>
                            <!-- </div>
                        </div> -->

                    </div>
                </div>
            </div>
        </div>

        
        <div id="laporkanMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Laporan Soal Nomor {{idxSoal}}</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <textarea class="form-control" rows="4" v-model="ket_laporan" readonly></textarea>
                            </div>
                        </form>
                    </div>
                    <!-- <div class="modal-footer">                        
                        <div class="submit-section float-center">
                            <button class="btn btn-primary submit-btn" @click.prevent="setLaporan()">Simpan</button>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import Sidebar from '../../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery';


export default {
    components: {
        Sidebar,
    },
	name: 'Materi',
    data() {
        return {
            lsttryout: [],
            lstsubject: [],
            tryout: {
                id_to: '',
                nama_to: '',
                id_materi: '',
                id_sub_materi: '',
                nama_materi: '',
                nama_sub_materi: '',
                url: '',
                waktu: '',
                hasil: '',
            },
            lstsoal: [],
            index: '', idxSoal: '', soal: '', list_jawaban: '', data: {soal:'', list_jawaban:''},
            ket_laporan: '',
            defsoal:{
               id_soal: '',
               id_to:'',
               uraian_soal:'',
               pembahasan:'',
               jawaban:-1,
               ket_laporan:''
            },
            deflist_jawaban: [
                {id_jawaban: '', jawaban: 'A', uraian_jawaban: "Opsi A", poin: 0},
                {id_jawaban: '', jawaban: 'B', uraian_jawaban: "Opsi B", poin: 0},
                {id_jawaban: '', jawaban: 'C', uraian_jawaban: "Opsi C", poin: 0},
                {id_jawaban: '', jawaban: 'D', uraian_jawaban: "Opsi D", poin: 0},
                {id_jawaban: '', jawaban: 'E', uraian_jawaban: "Opsi E", poin: 0}
            ],
            
            countDown : 0,
		 minutes:0,
		 secondes:0,
		 time:0,
		 timer:null,
        }
    },
    created: function () {
        // this.soal = this.defsoal; 
        // this.list_jawaban = this.deflist_jawaban;
        // console.log(this.$route.params.id);
        this.getTryout();
        this.getSoal();
        // this.getAll();
        // this.getAllMateri();
        // this.getAllSubMateri();
    },  
    // computed: {
    //     classObject: function (idx) {
    //         return {
    //         active: this.soal.active,
    //         'timing': false
    //         }
    //     }
    // },
    computed: {
		prettyTime () {
			 let time = this.time / 60
			 let minutes = parseInt(time)
			 let secondes = Math.round((time - minutes) * 60)
			 return minutes+":"+secondes
		}
	},
    methods: {
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    // "lengthMenu": [
                    //     [10, 25, 50, -1],
                    //     [10, 25, 50, "All"]
                    // ],
                    // order: [[0, 'asc'], [3, 'desc']],
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,

                });
               }, 300)
        },
        start () {
            
			 this.isRunning = true
			 if (!this.timer) {
				  this.timer = setInterval( () => {
						if (this.time > 0) {
							this.time--;
                            localStorage.setItem("time", this.time);
						} else {
							 clearInterval(this.timer)
							 this.sound.play()
							 this.reset()
						}
				  }, 1000 )
			 }
		 },
		 setTime (waktu) {
			//  this.time = waktu * 60 ; //(payload.minutes * 60 + payload.secondes)
            if(typeof localStorage.getItem("time") !== 'undefined' && localStorage.getItem("time")!= null ){
                this.time = localStorage.getItem("time");
            }
            else {
                this.time = waktu * 60 ;
            }
            
		 },
         reset () {
			this.stop()
			this.time = 0
			this.secondes = 0
			this.minutes = 0
            localStorage.setItem("time", this.time);

		 },
		//  stop () {
		// 	 this.isRunning = false
		// 	 clearInterval(this.timer)
		// 	 this.timer = null
		//  },
		

        selectOption : function(idx) {
            this.soal.jawaban = idx;  
            this.lstsoal[this.index].soal = this.soal;       
            localStorage.setItem("lstsoal", JSON.stringify(this.lstsoal));
        },
        
        getLaporan : function() {      
            this.ket_laporan = this.soal.ket_laporan;            
            $("#laporkanMdl").modal('show');
        },

        setLaporan : function() {
            this.soal.ket_laporan = this.ket_laporan;  
            console.log(this.soal.ket_laporan);
            this.lstsoal[this.index].soal = this.soal;       
            localStorage.setItem("lstsoal", JSON.stringify(this.lstsoal));
            this.ket_laporan = '';
            $("#laporkanMdl").modal('hide');
        },

        countDownTimer() {
            if(this.countDown > 0) {
                setTimeout(() => {
                    this.countDown -= 1
                    this.countDownTimer()
                }, 1000)
            }
        },

        //--------------------------
        getTryout: function () {
            axios.get('api/tryoutresUser/'+localStorage.getItem("id_to")+'/'+localStorage.getItem("id_user_to")) //this.$route.params.id)
                .then(res => {
                    // console.log(res.data);
                    this.tryout = res.data.data;
                    this.initDt("tblLatihan");
                    
                    // this.countDown = this.tryout.waktu * 60;
                    // this.countDownTimer();
                    // this.setTime(this.tryout.waktu);
                    // this.start();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        getSoal: function () {
            // if(typeof localStorage.getItem("lstsoal") !== 'undefined' && localStorage.getItem("lstsoal")!= null ){
            //     this.lstsoal = JSON.parse(localStorage.getItem("lstsoal") || '[]');
            //     console.log("masuk ada local storage:");
            //     console.log(this.lstsoal[0]);
            //     if(!this.lstsoal){
            //         this.setRowSoal(0);
            //     }
            // }
            // else {
                // console.log("tidak masuk ada local storage:");
               
                axios.get('api/soalByToResUser/'+localStorage.getItem("id_to")+'/'+localStorage.getItem("id_user_to")) //+this.$route.params.id)
                    .then(res => {
                        this.lstsoal = res.data.data;
                        localStorage.setItem("lstsoal", JSON.stringify(this.lstsoal));
                        if(this.lstsoal){
                            this.setRowSoal(0);
                        }
                        // console.log(this.lstsoal[0].soal.pembahasan);
                        // this.initDt("tblLatihan");
                    })
                    .catch(err => {
                        // handle error
                        console.log(err);
                    })
            // }
        },

        // Get Materi
        getAll: function () {
            axios.get('api/tryout')
                .then(res => {
                    // console.log(res.data);
                    this.lsttryout = res.data.data;
                    // this.initDt("tblLatihan");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Set Row Soal
        setRowSoal: function (index) {
                console.log("ini index before : " +index);
            if(index < 0)
                index = 0;

            if(this.lstsoal.length > index){
                this.index = index;
                this.idxSoal = index+1;
                this.soal = this.lstsoal[index].soal;

                this.list_jawaban = this.lstsoal[index].list_jawaban;
                // this.lstsoal[index].active = true;
                console.log("ini index : " +this.index);
                console.log(this.soal);
            } 
            // else {
            //     this.addNewSoal();
            // }

        },

        // Add New Soal
        addNewSoal: function () {
            this.soal = this.defsoal; this.list_jawaban = this.deflist_jawaban;
            this.save();
            this.data.soal = this.soal; 
            this.data.list_jawaban= this.list_jawaban;
            this.lstsoal.push(this.data);
            this.idxSoal = this.lstsoal.length;
            this.index = this.lstsoal.length-1;
        },
        
        updatePoin() {
            // console.log("jawaban : "+this.soal.jawaban);
            // if(this.soal.jawaban.length == 1){
            //     this.setPoin(jwb, index);
            // }else{
                this.resetPoin();
                this.soal.jawaban.split('').forEach((jwb,index ) => {
                    this.setPoin(jwb, index);
                });                
            // }

        },

        setPoin(xopsi, idxpoin){
            this.list_jawaban.forEach((opsi,index ) => {
                if(opsi.jawaban == xopsi){
                    var xpoin =0;
                    switch(idxpoin){
                        case 0: xpoin=5; break;
                        case 1: xpoin=4; break;
                        case 2: xpoin=3; break;
                        case 3: xpoin=2; break;
                        case 4: xpoin=1; break;
                    }
                    // console.log("opsi:"+xopsi+" - poin: " + xpoin);
                    opsi.poin = xpoin;
                    this.$set(this.list_jawaban, index, opsi);
                    // console.log("poin updt : " + this.list_jawaban[index].poin);
                }
            });
        },

        resetPoin(){
            this.list_jawaban.forEach((opsi,index ) => {
                opsi.poin = 0;
                this.$set(this.list_jawaban, index, opsi);
            });
        },

        // Batal TryOut Mdl
        getBatal: function (ref) {
            // this.resetVar(ref);
            $("#batalMdl").modal('show');
        },
        
        // Batal Tryout
        batal: function () {
            this.$router.push({name:'admin-tryout'}); 
        },

        // Create New Soal
        selesai: function () {
            axios.post('api/usertryout', {
                    'id_to': this.tryout.id_to, 
                    'created_by': '12345', //this.user.id_user
                    'waktu': this.time,
                    list_soal_jawaban: this.lstsoal
                })
                .then(res => {
                    $("#selesaiMdl").modal('hide');
                    this.tryout.hasil = res.data.data;
                    // $("#nilaiMdl").modal('show');

                    let timerInterval
                    swal.fire({
                    title: 'Tryout Selesai',
                    html: '<div class="success-cont">'+
                                '<i class="fas fa-check"></i>'+
                                '<h3>Selamat anda telah menyelesaikan Tryout '+this.tryout.nama_to+'!</h3>'+
                                '<p>Nilai yang anda dapatkan adalah <strong> '+this.tryout.hasil+'</strong></p>'+
                                // '<router-link to="/admin/tryout" class="btn btn-primary view-inv-btn">Selesai</router-link>'+
                            '</div>',
                    timer: 4000,
                    timerProgressBar: true,
                    didOpen: () => {
                        swal.showLoading()
                        const b = swal.getHtmlContainer().querySelector('b')
                        timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft()
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                    }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === swal.DismissReason.timer) {
                        // console.log('I was closed by the timer')
                        this.$router.push({name:'admin-tryout'});
                    }
                    })

                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Create New Soal
        save: function () {
            axios.post('api/soal', {
                    id_soal: this.soal.id_soal,
                    id_to: this.tryout.id_to,
                    uraian_soal: this.soal.uraian_soal,
                    pembahasan: this.soal.pembahasan,
                    jawaban: this.soal.jawaban,
                    list_jawaban: this.list_jawaban
                })
                .then(res => {
                    console.log( res.data.data.list_jawaban);
                    this.soal = res.data.data.soal;
                    this.list_jawaban = res.data.data.list_jawaban;
                    console.log( this.soal);
                    console.log( this.list_jawaban);


                    // handle success
                    // this.getAll();
                    // this.resetVar();
                    // $("#addMdl").modal('hide');
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        // Delete Soal
        hapus: function () {

            // if(this.soal.id_soal != ''){
            //     this.$delete(this.lstsoal, this.idxSoal);
            //     this.setRowSoal(this.index);
            // } else {
                axios.post('api/soaldel', {
                        id_soal: this.soal.id_soal
                    })
                    .then(res => {
                        if(res.data.status == "success"){
                            this.$delete(this.lstsoal, this.index);
                            this.setRowSoal(this.index-1);
                        }
                    })
                    .catch(err => {
                        // handle error
                        console.log(err);
                    })
            // }
        },

        filterSubject: function(value){
            this.tryout.id_sub_materi = '';
            this.lstsubject = value? this.lstsubmateri.filter(c => c.id_materi == value) : this.lstsubmateri;
        },

        resetVar: function(ref,isDasabled=false){
            if(ref){                
                this.tryout.id_to = ref.id_to;
                this.tryout.nama_to = ref.nama_to;
                this.tryout.id_materi = ref.id_materi;
                this.tryout.id_sub_materi = ref.id_sub_materi;
            } else {
                this.tryout.id_to = '';
                this.tryout.nama_to = '';
                this.tryout.id_materi = '';
                this.tryout.id_sub_materi = '';
            }
            
            $("#frm input").prop("disabled", isDasabled);
            $("#frm v-select").prop("disabled", isDasabled);
        },

        // Get Detail and Show data to Modal
        getDetail: function (ref) {
            this.resetVar(ref, true);
            $("#addMdl").modal('show');
        },
 
        // Get Edit and Show data to Modal
        getEdit: function (ref) {
            this.resetVar(ref);
            $("#addMdl").modal('show');
        },

        // Get Delete and Show Confirm Modal
        getDelete: function (ref) {
            this.resetVar(ref);
            $("#delMdl").modal('show');
        },
 
        
        
        //--------------------------
        // Get Materi
        // getAllMateri: function () {
        //     axios.get('api/materi')
        //         .then(res => {
        //             // console.log(res.data);
        //             this.lstmateri = res.data.data;
        //         })
        //         .catch(err => {
        //             // handle error
        //             console.log(err);
        //         })
        // },

        // Get sub_materi
        getAllSubMateri: function () {
            axios.get('api/submateri')
                .then(res => {
                    // console.log(res.data);
                    this.lstsubmateri = res.data.data;
                    this.lstsubject = this.lstsubmateri;
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Admin/Tryout/Pembahasan/index.vue